import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import './BrandPartners.css';
import kisanLogo from '../assets/kisan.png';
import shaktimanLogo from '../assets/shaktiman.png';
import bcsLogo from '../assets/bcs.png';
import yanmarLogo from '../assets/yanmar.png';
import agribullLogo from '../assets/trb.jpeg';
import kraftLogo from '../assets/kraft.jpeg';
import dashmeshLogo from '../assets/dasmes.jpeg';
import tataLogo from '../assets/tata_autocomp.jpg';

const BrandPartners = () => {
  const { t } = useTranslation();

  const brands = useMemo(() => [
    { name: 'Kisan', sub: t('brand_partners.in_house'), color: '#4ba242', bg: '#eef8ee', logo: kisanLogo },
    { name: 'Shaktiman', sub: t('brand_partners.authorized_dealer'), color: '#e8762e', bg: '#fff5ef', logo: shaktimanLogo },
    { name: 'BCS', sub: t('brand_partners.premium_equip'), color: '#fbc02d', bg: '#fffdeb', logo: bcsLogo },
    { name: 'Agribull', sub: t('brand_partners.power_solutions'), color: '#4ba242', bg: '#eef8ee', logo: agribullLogo },
    { name: 'Yanmar', sub: t('brand_partners.japanese_tech'), color: '#e8762e', bg: '#fff5ef', logo: yanmarLogo },
    { name: 'KisanKraft', sub: t('brand_partners.kisankraft'), color: '#fbc02d', bg: '#fffdeb', logo: kraftLogo },
    { name: 'Dashmesh', sub: t('brand_partners.dashmesh'), color: '#4ba242', bg: '#eef8ee', logo: dashmeshLogo },
    { name: 'Tata Autocomp', sub: t('brand_partners.tata', 'Genuine Spares Partner'), color: '#2563eb', bg: '#eff6ff', logo: tataLogo },
    { name: 'Vardman', sub: t('brand_partners.vardman'), color: '#e8762e', bg: '#fff5ef', logo: null },
    { name: 'Manku', sub: t('brand_partners.manku'), color: '#fbc02d', bg: '#fffdeb', logo: null },
    { name: 'Moga', sub: t('brand_partners.moga'), color: '#4ba242', bg: '#eef8ee', logo: null },
    { name: 'Gagandeep', sub: t('brand_partners.gagandeep'), color: '#e8762e', bg: '#fff5ef', logo: null }
  ], [t]);

  const CustomTractorIcon = ({ color }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="110" height="110" viewBox="0 0 64 64" fill="none">
      <path d="M26.6631 29.3295L55.9925 31.7291C56.6524 31.8589 57.2389 32.2332 57.6345 32.7771C58.03 33.321 58.2055 33.9943 58.1256 34.6621L56.3525 45.7486C56.2522 46.375 55.9319 46.9452 55.4491 47.3567C54.9663 47.7682 54.3525 47.994 53.7182 47.9937H53.3262" stroke={color} strokeWidth="5.33262" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M42.6609 47.9937H29.3293" stroke={color} strokeWidth="5.33262" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M47.9937 13.3315C47.2866 13.3315 46.6084 13.6125 46.1083 14.1125C45.6083 14.6125 45.3274 15.2907 45.3274 15.9979V30.8572" stroke={color} strokeWidth="5.33262" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M7.99902 10.6653H29.6735C30.3171 10.6657 30.9388 10.8988 31.424 11.3217C31.9091 11.7446 32.225 12.3288 32.3131 12.9663L34.6621 29.9854" stroke={color} strokeWidth="5.33262" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M10.6653 29.3295V10.6653" stroke={color} strokeWidth="5.33262" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M18.6643 39.9946H18.691" stroke={color} strokeWidth="5.33262" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M21.3306 26.9298V10.6653" stroke={color} strokeWidth="5.33262" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M47.9935 53.3263C50.9386 53.3263 53.3261 50.9388 53.3261 47.9936C53.3261 45.0485 50.9386 42.661 47.9935 42.661C45.0484 42.661 42.6609 45.0485 42.6609 47.9936C42.6609 50.9388 45.0484 53.3263 47.9935 53.3263Z" stroke={color} strokeWidth="5.33262" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M18.6641 53.3262C26.0269 53.3262 31.9956 47.3575 31.9956 39.9946C31.9956 32.6318 26.0269 26.6631 18.6641 26.6631C11.3013 26.6631 5.33252 32.6318 5.33252 39.9946C5.33252 47.3575 11.3013 53.3262 18.6641 53.3262Z" stroke={color} strokeWidth="5.33262" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );

  return (
    <section className="brand-partners">
      <div className="container">
        <div className="section-header">
          <span className="badge-tag">{t('brand_partners.badge')}</span>
          <h2 className="section-title">{t('brand_partners.title')}</h2>
          <p className="section-subtitle">
            {t('brand_partners.subtitle')}
          </p>
        </div>

        <div className="brands-marquee-container">
          <div className="brands-marquee-track">
            {brands.map((brand, index) => (
              <div key={`orig-${index}`} className="brand-card" style={{ borderColor: brand.color, backgroundColor: brand.bg }}>
                <div className="brand-icon">
                  {brand.logo ? (
                    <img src={brand.logo} alt={brand.name} className="brand-logo-img" />
                  ) : (
                    <CustomTractorIcon color={brand.color} />
                  )}
                </div>
                <h3 className="brand-name">{brand.name}</h3>
                <p className="brand-desc">{brand.sub}</p>
              </div>
            ))}
            {brands.map((brand, index) => (
              <div key={`dup-${index}`} className="brand-card" style={{ borderColor: brand.color, backgroundColor: brand.bg }} aria-hidden="true">
                <div className="brand-icon">
                  {brand.logo ? (
                    <img src={brand.logo} alt={brand.name} className="brand-logo-img" />
                  ) : (
                    <CustomTractorIcon color={brand.color} />
                  )}
                </div>
                <h3 className="brand-name">{brand.name}</h3>
                <p className="brand-desc">{brand.sub}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="footer-stats">
          <div className="f-stat-item green">
            <h4 className="f-stat-val">20+</h4>
            <p className="f-stat-label">{t('brand_partners.brand_partners')}</p>
          </div>
          <div className="f-stat-item orange">
            <h4 className="f-stat-val">150+</h4>
            <p className="f-stat-label">{t('brand_partners.equip_types')}</p>
          </div>
          <div className="f-stat-item yellow">
            <h4 className="f-stat-val">100%</h4>
            <p className="f-stat-label">{t('brand_partners.genuine_products')}</p>
          </div>
        </div>
      </div>

    </section>
  );
};

export default BrandPartners;


